import React from "react"

import { InsuranceOfferContext, InsuranceOfferProvider } from "./InsuranceOffer"

const ContextProviders = ({ children }) => <InsuranceOfferProvider>{children}</InsuranceOfferProvider>

ContextProviders.displayName = "ContextProviders"
export default ContextProviders
export { InsuranceOfferContext }
